import { render, staticRenderFns } from "./HeaderLogo.vue?vue&type=template&id=fb242458&scoped=true"
import script from "./HeaderLogo.vue?vue&type=script&lang=js"
export * from "./HeaderLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb242458",
  null
  
)

export default component.exports